import { Box } from '@factorialco/deprecated-design-system'

import { formatValue } from 'modules/core/components/ActivityLog/Log/functions'
import { ChangeValue } from 'modules/core/components/ActivityLog/Log/types'

interface Props {
  value: ChangeValue
}

export const Comment = ({ value }: Props) => {
  return (
    <Box
      border={{ all: { width: 's2', color: 'grey300', style: 'solid' } }}
      borderRadius={{ all: 'abs016', topLeft: 'abs002' }}
      background="grey100"
      padding="s8"
      width="fit-content"
    >
      {formatValue(value.value)}
    </Box>
  )
}
